<script>
import {FullScreen, OffScreen, Bell, Like, Star, Comment} from "@icon-park/vue-next";
import axios from "axios";
import Cookies from "js-cookie";
import user from "@icon-park/vue-next/lib/icons/User";
import waterMark from "@/components/waterMark";
import JSEncrypt from "jsencrypt";
import {ElLoading} from "element-plus";
import {SUPPORT_EMAIL} from "@/utils/constants";
import notificationService from "@/utils/notificationService";

export default {
    name: 'Header',
    computed: {
        user() {
            return user
        }
    },
    components: {FullScreen, OffScreen, Bell, Like, Star, Comment},
    data() {
        return {
            publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtymK3FehfOYk/oKmRhAOGxI0IeVCJeKOFK21X4tsZ0RRUoyeLpZY+VB8D9rLDhdKDvIt2FZRp9a4R0v2IfwIz+VkwW9auA53ecPh7NCFANTGLtP8hZpXBVtE9mgOLQ8jL7GXVUkTXxbcYEuXi/fnx41p2bEXUGHjYZJXrmCxpaKrXB5asMbiB5QiMFg3SVXKzJ47DzqPjHG2+sfhR6U7YsZrefbwEs+/lQ4L48bpHcQeL/VyoKn+XuelD2nOWs00rcLRlsgB4qNRk9m0dwe2RS74P0+igmuv09EoPggm2wrZz7blrwkBdrSrJxGcVXJVf1GscDYRQaBYiUYqpKo9OQIDAQAB",
            fullscreen: false,
            userType: "",
            waterMarkUserType: "",
            waterMarkUserName: "",
            waterMarkUserId: "",
            showInfo: false,
            updatePasswordDialogWidth: '800px',
            dialogWidth: '1000px',
            dialogMinWidth: '400px',
            user: {},
            form: {},
            rules: {},
            classList: [],
            updatePasswordDialogVisible: false,
            updatePasswordForm: {},
            updatePasswordFormRules: {},
            // 通知相关
            notifications: [],
            unreadCount: 0,
            showNotificationPopover: false,
            ws: null,
            wsReconnectTimer: null,
            wsReconnectCount: 0,
            maxReconnectCount: 5,
            notificationLoading: false,
        }
    },
    mounted() {
        // 监听全屏状态变化
        this.addFullscreenListener();
        // 初始化时检查当前是否为全屏状态
        this.checkFullscreenState();
        // 监听键盘事件
        document.addEventListener('keydown', this.handleKeydown);
        // 更新个人信息对话框宽度
        this.updateDialogWidth();
        window.addEventListener('resize', this.updateDialogWidth);
        waterMark.set(this.waterMarkUserType + this.waterMarkUserName + this.waterMarkUserId);
        // 初始化WebSocket连接
        this.initWebSocket(this.user.id);
        // 获取通知列表
        this.fetchNotifications();
    },
    beforeUnmount() {
        // 组件销毁前移除监听器
        this.removeFullscreenListener();
        // 移除键盘事件监听
        document.removeEventListener('keydown', this.handleKeydown);
        // 移除窗口大小监听器
        window.removeEventListener('resize', this.updateDialogWidth);
        // 关闭WebSocket连接
        notificationService.close();
    },
    created() {
        this.userType = localStorage.getItem("userType");
        if (!this.userType) {
            this.$message({
                type: "error",
                message: "请登录后访问"
            })
            return;
        }
        if (this.userType === "teacher") {
            this.rules = {
                birthday: [
                    {required: true, message: '请选择生日', trigger: 'blur'},
                ],
                gender: [
                    {required: true, message: '请选择性别', trigger: 'blur'},
                ],
                classList: [
                    {required: true, message: '请选择班级', trigger: 'blur'},
                ],
            }
        }
        if (this.userType === "student") {
            this.rules = {
                birthday: [
                    {required: true, message: '请选择生日', trigger: 'blur'},
                ],
                classCode: [
                    {required: true, message: '请选择班级编码', trigger: 'blur'},
                ],
                gender: [
                    {required: true, message: '请选择性别', trigger: 'blur'},
                ],
            }
        }
        axios.get("/api/sign-in/getUser", {
            params: {
                userType: this.userType,
                jwtToken: localStorage.getItem("jwt-" + this.userType)
            }
        }).then(res => {
            if (res.data.code === "200") {
                this.user = res.data.data;
                this.waterMarkUserType = this.user.role;
                this.waterMarkUserName = this.user.name;
                this.waterMarkUserId = this.user.id;
                // 将res.data.data.classList由数组转换为字符串，使用,连接
                if (this.user.classList) {
                    this.user.classList = this.user.classList.join(',');
                }
                this.form = {...this.user};
                if (this.user.isInfoFull === 0) {
                    this.$notify({
                        type: "warning",
                        title: "完善信息",
                        message: "请完善个人信息",
                        duration: 0,
                        position: "bottom-right"
                    })
                }
                waterMark.set([this.waterMarkUserType, this.waterMarkUserName, this.waterMarkUserId]);
                // 用户信息加载成功后，初始化WebSocket连接
                this.initWebSocket(this.user.id);
                // 获取通知列表
                this.fetchNotifications();
            } else if (res.data.code === "401") {
                localStorage.removeItem("userType");
                this.user = {};
                window.location.reload();
                if (res.data.message !== "请登录") {
                    this.$notify({
                        type: "warning",
                        title: "登录过期",
                        message: res.data.code + "--" + res.data.message
                    })
                }
            } else if (res.data.code === "403") {
                if (res.data.message === "账号被禁用") {
                    this.$notify({
                        type: "error",
                        title: "账号异常",
                        message: res.data.code + "--" + res.data.message
                    })
                    this.signOut();
                }
            } else {
                this.$notify({
                    type: "error",
                    title: "未检测到用户",
                    message: res.data.code + "--" + res.data.message
                })
            }
        }).catch((error) => {
            this.$notify({
                type: "error",
                title: "请求失败",
                dangerouslyUseHTMLString: true,
                message: "<div style='color: #F56C6C'>服务器发生错误，请求失败！</div>" +
                    "<div style='color: #F56C6C'>请联系管理员：</div>" +
                    "<a href='`mailto:${SUPPORT_EMAIL}`' style='text-decoration: none; color: #409EFF;'>" + SUPPORT_EMAIL + "</a>" +
                    "<div>主题：请求发生异常</div>" +
                    "<div>正文：<br>/sign-in/getUser/" + this.userType + "<br> + 您刚刚是如何操作的</div>",
                duration: 0,
                position: "bottom-right"
            })
        });
        const userType = localStorage.getItem('userType');
        const jwtToken = localStorage.getItem(userType === 'teacher' ? 'jwt-teacher' : 'jwt-student');
        axios.get('/api/class/list', {
            params: {
                jwtToken: jwtToken ? jwtToken : null
            }
        }).then(res => {
            if (res.data.code === "200") {
                this.classList = res.data.data;

            }
        }).catch((err) => {
            this.$notify({
                type: "error",
                title: "请求失败",
                dangerouslyUseHTMLString: true,
                message: "<div style='color: #F56C6C'>服务器发生错误，请求失败！</div>" +
                    "<div style='color: #F56C6C'>请联系管理员：</div>" +
                    "<a href='`mailto:${SUPPORT_EMAIL}`' style='text-decoration: none; color: #409EFF;'>" + SUPPORT_EMAIL + "</a>" +
                    "<div>主题：请求发生异常</div>" +
                    "<div>正文：<br>/class/list/" + "<br> + 您刚刚是如何操作的</div>",
                duration: 0,
                position: "bottom-right"
            })
        });
    },
    methods: {
        addFullscreenListener() {
            // 监听全屏变化事件（兼容不同浏览器）
            document.addEventListener('fullscreenchange', this.handleFullscreenChange);
            document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
            document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
            document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
        },
        removeFullscreenListener() {
            document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
        },
        checkFullscreenState() {
            // 检查当前是否处于全屏状态
            this.fullscreen = !!(document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement);
        },
        handleFullscreenChange() {
            // 当全屏状态变化时更新组件状态
            this.checkFullscreenState();
        },
        handleKeydown(event) {
            // 监听F11按键
            if (event.keyCode === 122 || event.key === 'F11') {
                // 阻止浏览器默认的全屏行为
                event.preventDefault();
                // 执行自定义的全屏切换逻辑
                this.handleFullScreen();
            }
        },
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
        },
        open() {
            this.$confirm("确认退出登录吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.signOut();
            }).catch(() => {
            });
        },
        signOut() {
            localStorage.removeItem("jwt-" + this.userType);
            Cookies.remove("jwt-" + this.userType);
            localStorage.removeItem("userType");
            window.location.reload();
        },
        updateDialogWidth() {
            const viewportWidth = window.innerWidth;
            // 根据视口宽度动态设置对话框宽度
            if (viewportWidth < 500) {
                this.dialogWidth = '95%';
            } else if (viewportWidth < 1200) {
                this.dialogWidth = Math.max(viewportWidth * 0.8, 400) + 'px';
            } else {
                this.dialogWidth = '1000px';
                this.updatePasswordDialogWidth = '800px';
            }
        },
        disabledDate(time) {
            return time.getTime() > Date.now();
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // 处理教师的classList字段
                    let classList = [];
                    if (this.userType === 'teacher' && this.form.classList) {
                        // 把表单中的classList字符串中的所有中文逗号换成英文逗号
                        this.form.classList = this.form.classList.replace(/，/g, ",");
                        // 把classList字符串根据逗号进行分割，并返回一个数组
                        classList = this.form.classList.split(",");
                    }

                    // 格式化日期
                    let birthdayStr = null;
                    if (this.form.birthday) {
                        // 将Date对象转换为"yyyy-MM-dd"格式的字符串
                        if (this.form.birthday instanceof Date) {
                            const date = new Date(this.form.birthday.getTime() - this.form.birthday.getTimezoneOffset() * 60000)
                            birthdayStr = date.toISOString().split('T')[0];
                        } else if (typeof this.form.birthday === 'string') {
                            // 如果已经是字符串，直接使用
                            birthdayStr = this.form.birthday;
                        }
                    }

                    const data = {
                        id: this.form.id,
                        name: this.form.name,
                        gender: this.form.gender,
                        birthday: birthdayStr,
                        email: this.form.email,
                        classCode: this.form.classCode,
                        createTime: this.form.createTime,
                        status: this.form.status,
                        role: this.form.role,
                        classList: classList,
                    }
                    axios.put('/api/user/update/' + this.userType, data, {
                        headers: {
                            Authorization: localStorage.getItem("jwt-" + this.userType)
                        }
                    }).then((res) => {
                        if (res.data.code === "200") {
                            this.showInfo = false;
                            this.$message({
                                type: "success",
                                message: "修改成功！",
                                duration: 4000
                            });
                        } else if (res.data.code === "400") {
                            // 参数错误
                            this.$message({
                                type: "error",
                                message: res.data.code + "---" + res.data.message,
                                duration: 4000
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: res.data.code + "---" + res.data.message,
                                duration: 4000
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            type: "error",
                            title: "请求失败",
                            dangerouslyUseHTMLString: true,
                            message: "<div style='color: #F56C6C'>服务器发生错误，请求失败！</div>" +
                                "<div style='color: #F56C6C'>请联系管理员：</div>" +
                                "<a href='`mailto:${SUPPORT_EMAIL}`' style='text-decoration: none; color: #409EFF;'>" + SUPPORT_EMAIL + "</a>" +
                                "<div>主题：请求发生异常</div>" +
                                "<div>正文：<br>/user/update/" + this.userType + "<br> + 您刚刚是如何操作的</div>",
                            duration: 0,
                            position: "bottom-right"
                        })
                    })
                } else {
                    this.$message({
                        type: "error",
                        message: "请按照提示更改信息！",
                        duration: 4000
                    });
                    return false;
                }
            });
        },
        updatePassword() {
            this.updatePasswordForm = {};
            this.updatePasswordDialogVisible = true;
        },
        updatePasswordSubmit() {
            if (this.updatePasswordForm.newPassword !== this.updatePasswordForm.confirmPassword) {
                this.$message({
                    type: "error",
                    message: "两次输入的密码不一致！",
                    duration: 4000
                })
                return;
            }
            let loadingInstance = ElLoading.service({
                target: '.el-dialog',
                text: 'Loading...',
                background: 'rgba(255,255,255,0.8)'
            });

            const jsEncrypt = new JSEncrypt();
            jsEncrypt.setPublicKey(this.publicKey);
            const data = {
                oldPassword: jsEncrypt.encrypt(this.updatePasswordForm.oldPassword),
                newPassword: jsEncrypt.encrypt(this.updatePasswordForm.newPassword),
                confirmPassword: jsEncrypt.encrypt(this.updatePasswordForm.confirmPassword)
            }

            axios.put('/api/sign-in/updatePassword/' + this.userType, data, {
                headers: {
                    Authorization: localStorage.getItem("jwt-" + this.userType)
                }
            }).then((res) => {
                if (res.data.code === "200") {
                    this.updatePasswordDialogVisible = false;
                    this.updatePasswordForm = {};
                    this.$notify({
                        type: "success",
                        title: "更改成功",
                        message: "密码更改成功，下次登录须输入新密码！",
                        duration: 6000
                    });
                } else if (res.data.code === "400") {
                    this.$notify({
                        type: "warning",
                        title: "更改失败",
                        message: "请确认两次密码是否相同，并确定旧密码正确！",
                        duration: 6000
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: res.data.code + res.data.message,
                        duration: 6000
                    });
                }
                loadingInstance.close();
            }).catch((error) => {
                loadingInstance.close();
                this.$notify({
                    type: "error",
                    title: "请求失败",
                    dangerouslyUseHTMLString: true,
                    message: "<div style='color: #F56C6C'>服务器发生错误，请求失败！</div>" +
                        "<div style='color: #F56C6C'>请联系管理员：</div>" +
                        "<a href='`mailto:${SUPPORT_EMAIL}`' style='text-decoration: none; color: #409EFF;'>" + SUPPORT_EMAIL + "</a>" +
                        "<div>主题：请求发生异常</div>" +
                        "<div>正文：<br>/sign-in/updateAdminPassword" + "<br> + 您刚刚是如何操作的</div>",
                    duration: 0,
                    position: "bottom-right"
                })
            })
        },
        // 通知相关方法
        initWebSocket(userId) {
            // 确保 userId 有效后再连接
            if (!userId) {
                console.warn("userId 为空，推迟 WebSocket 连接");
                return;
            }
            notificationService.init(
                this.userType,
                userId,
                (notification) => {
                    // 处理新通知
                    this.handleNewNotification(notification);
                },
                (connected) => {
                    // 连接状态变化
                    console.log("WebSocket连接状态:", connected ? "已连接" : "已断开");
                }
            );
        },
        fetchNotifications() {
            this.notifications = [];
            this.updateUnreadCount();
        },
        handleNewNotification(notification) {
            // 批量处理通知：如果是数组则替换整个列表，如果是单个对象则添加到头部
            if (Array.isArray(notification)) {
                this.notifications = notification;
            } else {
                this.notifications.unshift(notification);
            }
            this.updateUnreadCount();
            // 显示桌面通知（如果用户授权）
            if (!Array.isArray(notification)) {
                this.showDesktopNotification(notification);
            }
        },
        showDesktopNotification(notification) {
            if ("Notification" in window && Notification.permission === "granted") {
                new Notification("新通知", {
                    body: `${this.formatActorName(notification.actorName, notification.actorUserType)} ${notification.action}《${notification.lessonTitle}》`,
                    icon: "/favicon.ico"
                });
            }
        },
        updateUnreadCount() {
            this.unreadCount = this.notifications.filter(n => !n.isRead).length;
        },
        handleReadAll() {
            this.notificationLoading = true;
            notificationService.markAllAsRead(this.userType)
                .then(() => {
                    this.notifications.forEach(n => n.isRead = true);
                    this.updateUnreadCount();
                    this.$message({
                        type: "success",
                        message: "已全部标记为已读",
                        duration: 2000
                    });
                })
                .catch((error) => {
                    this.$message({
                        type: "error",
                        message: "操作失败: " + error.message,
                        duration: 3000
                    });
                })
                .finally(() => {
                    this.notificationLoading = false;
                });
        },
        handleClearAll() {
            this.$confirm("确定要清空所有通知吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.notificationLoading = true;
                notificationService.clearAll(this.userType)
                    .then(() => {
                        this.notifications = [];
                        this.updateUnreadCount();
                        this.$message({
                            type: "success",
                            message: "已清空所有通知",
                            duration: 2000
                        });
                    })
                    .catch((error) => {
                        this.$message({
                            type: "error",
                            message: "操作失败: " + error.message,
                            duration: 3000
                        });
                    })
                    .finally(() => {
                        this.notificationLoading = false;
                    });
            }).catch(() => {});
        },
        handleNotificationClick(notification) {
            // 标记为已读
            if (!notification.isRead) {
                notificationService.markAsRead(this.userType, notification.id)
                    .then(() => {
                        notification.isRead = true;
                        this.updateUnreadCount();
                    })
                    .catch(() => {
                        // 静默失败，不影响用户体验
                    });
            }
            // 构建路由参数
            const query = {};
            // 如果是评论或回复类型的通知，携带目标评论ID
            if ((notification.type === "comment" || notification.type === "reply") && notification.commentId) {
                query.targetCommentId = notification.commentId;
            }
            // 跳转到课程详情页
            this.$router.push({
                path: `/show_detail/${notification.lessonId}`,
                query: query
            });
            this.showNotificationPopover = false;
        },
        formatTime(time) {
            if (!time) return "";
            const date = new Date(time);
            const now = new Date();
            const diff = now - date;
            
            // 小于1分钟
            if (diff < 60000) {
                return "刚刚";
            }
            // 小于1小时
            if (diff < 3600000) {
                return Math.floor(diff / 60000) + "分钟前";
            }
            // 小于24小时
            if (diff < 86400000) {
                return Math.floor(diff / 3600000) + "小时前";
            }
            // 小于7天
            if (diff < 604800000) {
                return Math.floor(diff / 86400000) + "天前";
            }
            // 返回具体日期
            return date.toLocaleDateString();
        },
        formatActorName(actorName, actorUserType) {
            if (!actorUserType) return actorName;
            const typeText = actorUserType === 'teacher' ? '（教师）' : '（学生）';
            return actorName + typeText;
        },
        getNotificationIcon(type) {
            const iconMap = {
                like: "Like",
                favorite: "Star",
                comment: "Comment",
                reply: "Comment"
            };
            return iconMap[type] || "Bell";
        },
        getNotificationColor(type) {
            const colorMap = {
                like: "#F56C6C",
                favorite: "#E6A23C",
                comment: "#409EFF"
            };
            return colorMap[type] || "#909399";
        }
    }
}
</script>


<template>
    <!-- 将水印组件移到最外层 -->
    <!--<el-watermark
        :content="[waterMarkUserType, waterMarkUserName, waterMarkUserId]"
        :font="font"
        style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; pointer-events: none; z-index: 99999"
    />-->
    <div
        style="height: 100%; width: 100%; display: flex; align-items: center; float: right; padding-right: 20px;">
        <div class="flex-1"></div>
        
        <!-- 通知铃铛 -->
        <el-popover
            v-model:visible="showNotificationPopover"
            placement="bottom-end"
            :width="350"
            trigger="click"
            popper-class="notification-popover"
        >
            <template #reference>
                <el-badge :value="unreadCount" :hidden="unreadCount === 0" class="notification-badge">
                    <el-button text class="notification-btn">
                        <el-icon :size="20">
                            <bell :strokeWidth="3" fill="#333" size="25" theme="outline"/>
                        </el-icon>
                    </el-button>
                </el-badge>
            </template>
            
            <div class="notification-header">
                <span class="notification-title">通知</span>
                <div class="notification-actions">
                    <el-button 
                        link 
                        type="primary" 
                        size="small" 
                        @click="handleReadAll"
                        :loading="notificationLoading"
                    >
                        全部已读
                    </el-button>
                    <el-button 
                        link 
                        type="danger" 
                        size="small" 
                        @click="handleClearAll"
                        :loading="notificationLoading"
                    >
                        清空全部
                    </el-button>
                </div>
            </div>
            
            <el-divider style="margin: 10px 0;"/>

            <div v-if="notifications.length === 0" class="notification-empty">
                <div style="text-align: center; cursor: default; color: #999;">暂无通知</div>
            </div>
            
            <el-scrollbar v-else max-height="350px" class="notification-list">
                <div
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="notification-item"
                    :class="{ 'is-read': notification.isRead }"
                    @click="handleNotificationClick(notification)"
                >
                    <div class="notification-icon-wrapper">
                        <div 
                            class="notification-icon" 
                            :style="{ backgroundColor: getNotificationColor(notification.type) + '20' }"
                        >
                            <el-icon :size="16" :color="getNotificationColor(notification.type)">
                                <component :is="getNotificationIcon(notification.type)"/>
                            </el-icon>
                        </div>
                    </div>
                    <div class="notification-content">
                        <div class="notification-text">
                            <span class="actor-name">{{ formatActorName(notification.actorName, notification.actorUserType) }}</span>
                            {{ notification.action }}
                            <span class="lesson-title">《{{ notification.lessonTitle }}》</span>
                        </div>
                        <div class="notification-time">{{ formatTime(notification.createTime) }}</div>
                    </div>
                    <div v-if="!notification.isRead" class="unread-dot"></div>
                </div>
            </el-scrollbar>
        </el-popover>

        <!--删除通知铃铛和全屏按钮之间的分隔符-->
        <!--<el-text :size="'large'"-->
        <!--         style="cursor: default; padding: 0 15px 3px 15px; color: #000000;">-->
        <!--    |-->
        <!--</el-text>-->
        
        <el-tooltip
            class="box-item"
            content="全屏"
            effect="light"
            placement="bottom"
        >
            <el-button text @click="handleFullScreen">
                <el-icon :size="20">
                    <full-screen v-if="!fullscreen" :strokeWidth="3" fill="#333" size="25" theme="outline"/>
                    <off-screen v-if="fullscreen" :strokeWidth="3" fill="#333" size="25" theme="outline"/>
                </el-icon>
            </el-button>
        </el-tooltip>
        
        <el-text :size="'large'"
                 style="cursor: default; padding: 0 15px 3px 15px; color: #000000;">
            |
        </el-text>
        
        <el-dropdown v-if="userType" placement="bottom">
            <el-button text>
                <el-text :size="'large'" style="cursor: pointer;" tag="b">
                    {{ user.name }}
                </el-text>
            </el-button>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item @click="showInfo = true">个人信息</el-dropdown-item>
                    <el-dropdown-item @click="updatePassword">更改密码</el-dropdown-item>
                    <el-dropdown-item @click="open">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
        
        <div v-if="!userType">
            <a href="/sign-in" style="color: #409EFF">登录</a>
        </div>
        
        <el-dialog
            v-model="showInfo"
            :min-width="dialogMinWidth"
            :width="dialogWidth"
            center
            class="dialog-info"
            style="height: 98vh; margin: 1vh auto;"
            title="个人信息"
        >
            <div id="form">
                <el-form
                    ref="form"
                    :label-position="'right'"
                    :model="form"
                    :rules="rules"
                    class="form"
                >
                    <el-form-item label="姓名" prop="name">
                        <el-input
                            v-model="form.name"
                            disabled
                            placeholder="请输入姓名"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item v-if="userType === 'student'" label="学号" prop="id">
                        <el-input
                            v-model="form.id"
                            disabled
                            placeholder="请输入学号"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item v-if="userType === 'teacher'" label="工号" prop="id">
                        <el-input
                            v-model="form.id"
                            disabled
                            placeholder="请输入工号"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item label="性别" prop="gender">
                        <el-select
                            v-model="form.gender"
                            clearable
                            placeholder="请选择性别"
                            size="large"
                        >
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生日" prop="birthday">
                        <el-date-picker
                            v-model="form.birthday"
                            :default-value="user.birthday"
                            :disabled-date="disabledDate"
                            placeholder="选择日期"
                            size="large"
                            style="width: 100%"
                            type="date"
                        />
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input
                            v-model="form.email"
                            disabled
                            placeholder="请输入邮箱"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item v-if="userType === 'student'" label="班级号" prop="classCode">
                        <el-select
                            v-model="form.classCode"
                            placeholder="请选择班级编码"
                            size="large"
                        >
                            <el-option
                                v-for="item in classList"
                                :label="item.classCode"
                                :value="item.classCode"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="注册时间" prop="createTime">
                        <el-input
                            v-model="form.createTime"
                            disabled
                            placeholder="请选择注册时间"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item label="职务" prop="role">
                        <el-input
                            v-model="form.role"
                            disabled
                            placeholder="请输入职务"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item v-if="userType === 'teacher'" label="管理班级" prop="classList">
                        <el-input
                            v-model="form.classList"
                            placeholder="输入班级编码，用 &quot; , &quot; 隔开"
                            size="large"
                        />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-input
                            v-model="form.status"
                            disabled
                            placeholder="请输入状态"
                            size="large"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div id="button-bar">
                <el-button
                    class="button"
                    type="default"
                    @click="showInfo=false"
                >
                    关闭
                </el-button>
                <el-button
                    class="button"
                    type="primary"
                    @click="submit"
                >
                    保存
                </el-button>
            </div>
        </el-dialog>
        
        <el-dialog
            v-model="updatePasswordDialogVisible"
            :min-width="dialogMinWidth"
            :title="'更改密码'"
            :width="updatePasswordDialogWidth"
        >
            <el-form
                ref="updatePasswordForm"
                :model="updatePasswordForm"
                :rules="updatePasswordFormRules"
                class="updatePasswordForm"
            >
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input v-model="updatePasswordForm.oldPassword" placeholder="请输入旧密码" show-password
                              size="large"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input v-model="updatePasswordForm.newPassword" placeholder="请输入新密码" show-password
                              size="large"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="updatePasswordForm.confirmPassword" placeholder="再次输入新密码" show-password
                              size="large"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="updatePasswordDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="updatePasswordSubmit">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<style scoped>
#form {
    /*表单高度为dialog高度(98vh)减去dialog内边距、标题栏高度、标题栏内边距、按钮栏距离下边框的高度、按钮栏高度、按钮栏距表单距离(自定义)*/
    height: calc(98vh - 16px - 24px - 16px - 40px - 40px - 40px);
    overflow: auto;
}

.form {
    padding: 40px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
}

#button-bar {
    position: absolute;
    bottom: 40px;
    right: 56px;
}

.button {
    width: 150px;
    height: 40px;
    font-size: 18px;
}

:deep(.el-form-item__label) {
    display: inline-block;
    font-size: 16px;
    line-height: 40px;
    width: 95px;
}

/* 通知样式 */
.notification-badge {
    margin-right: 8px;
}

.notification-btn {
    padding: 8px;
}

.notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
}

.notification-title {
    font-weight: bold;
    font-size: 16px;
}

.notification-actions {
    display: flex;
    gap: 8px;
}

.notification-empty {
    padding: 20px 0;
}

.notification-list {
    max-height: 350px;
}

.notification-item {
    display: flex;
    align-items: flex-start;
    padding: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
}

.notification-item:hover {
    background-color: #f5f7fa;
}

.notification-item.is-read {
    opacity: 0.7;
}

.notification-icon-wrapper {
    margin-right: 12px;
    flex-shrink: 0;
}

.notification-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-content {
    flex: 1;
    min-width: 0;
}

.notification-text {
    font-size: 14px;
    line-height: 1.5;
    color: #303133;
    word-wrap: break-word;
}

.actor-name {
    font-weight: bold;
    color: #409EFF;
}

.lesson-title {
    color: #67C23A;
}

.notification-time {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
}

.unread-dot {
    width: 8px;
    height: 8px;
    background-color: #F56C6C;
    border-radius: 50%;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
}

/* 当屏幕较小时，每个表单项占满一行 */
@media (max-width: 768px) {
    .form {
        grid-template-columns: 1fr;
    }
}

/* 当屏幕较大时，每行显示两个表单项 */
@media (min-width: 769px) {
    .form {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>